import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel } from '../../uicomponent';
import { UIComponentView } from '../../uicomponentview';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { ArtistRowViewImpl } from './artistrowview';
import { ToneDto } from '../../../../core/dto/tonedto';
import { EnglishArtistRowCSSStyleImpl } from './englishartistrowcss';
import { BaseContext } from '../../../../utils/basecontext';
import { RoutingFeatures } from '../../../components/navigation/routingfeature';

export interface ArtistRowComponentProps extends UIComponentProps
{
    artistDto: ToneDto;
    position: number;
}

export interface ArtistRowComponentHandler extends UIComponentHandler
{
     onArtistRowSelected(): void;
}

export class ArtistRowComponent extends UIComponentImpl<ArtistRowComponentProps, UIComponentState, UIDataModel> 
implements ArtistRowComponentHandler
{
    constructor(props: ArtistRowComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ArtistRowViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new EnglishArtistRowCSSStyleImpl(applicationContext);
    }  
   
    onArtistRowSelected(): void 
    {
        this.props.context.getRedirectionHandler().routeNextFeature(this.props.context.getRoutingPath() +
            "/" + RoutingFeatures.ARTIST_SEARCH + "?searchkey=" + this.props.artistDto.getArtistName(), false);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/artist/artistrowcomponent.tsx